export const Enter = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.99997 20H26C26.5523 20 27 19.5523 27 19V10C27 9.44771 26.5523 9 26 9H13" stroke="currentColor" stroke-width="2"/>
<path d="M10.7065 14.6962L5.4104 19.9999L10.7116 25.2812" stroke="currentColor" stroke-width="2"/>
</svg>`;
